import React from 'react';

import { ChatSession } from './components/ChatSession';
import FixedFooter from './components/FixedFooter';
import { NewChat } from './components/NewChat';
import { useSelector } from 'react-redux';
import { selectCurrentSessionId, selectTemporarySessionId } from './slice/selectors';
import { Box, Container } from '@mui/material';
import useChatFormhandler from './hooks/useChatFormhandler';
import { useAutoScroll } from './hooks/useAutoScroll';

export default function ChatInterface() {
  const currentSessionId = useSelector(selectCurrentSessionId);
  const temporarySessionId = useSelector(selectTemporarySessionId);
  // const FOOTER_HEIGHT = 120;
  const chatFormProps = useChatFormhandler();
  const { containerRef, checkUserScroll } = useAutoScroll({ shouldScrollToBottom: !!(currentSessionId || temporarySessionId) });

  return (
    <>
      <Box sx={{ width: '100%', overflowY: 'auto', height: '100dvh ', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }} ref={containerRef} onScroll={checkUserScroll}>
        <Container sx={{ p: 0 }} maxWidth="lg">
          {currentSessionId || temporarySessionId ? <ChatSession streamingData={chatFormProps.streamingData} isStreaming={chatFormProps.isStreaming} /> : <NewChat {...chatFormProps} />}
        </Container>
        <Container maxWidth="lg" sx={{ width: '100%', p: 0, zIndex: 1000, position: 'sticky', bottom: 0, left: 0, right: 0 }}>
          <FixedFooter {...chatFormProps} />
        </Container>
      </Box>

      {/* <Box sx={{ left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', zIndex: (theme) => theme.zIndex.appBar, width: '100%' }}>
        <Container maxWidth="lg" sx={{ width: '100%' }}>
          <FixedFooter {...chatFormProps} />
        </Container>
      </Box> */}
    </>
  );
}
